import React from "react";
import { RotaButton } from "@teamrota/rota-design";

import {
  Action,
  Actions,
  BookingCount,
  Dialog,
  Heading,
  Message,
  Overlay,
} from "./styles";
import { useStreamStats } from "./graphql/use-stats";
import { COLORS } from "~/src/styles/config.style";

export const CancelModal: React.FC<{
  streams: any[];
  isLoading?: boolean;
  onProceed: () => void;
  onClose: () => void;
}> = ({ streams, isLoading, onProceed, onClose }) => {
  // fetch the stats to display number of affected bookings

  let totalAccepted = 0;
  let totalApplied = 0;
  let totalReserved = 0;

  for (const stream of streams) {
    const { stats } = useStreamStats(stream.id);

    totalAccepted += stats?.acceptedCount || 0;
    totalApplied += stats?.appliedCount || 0;
    totalReserved += stats?.reservedCount || 0;
  }

  return (
    <Overlay onClick={onClose}>
      <Dialog
        role="dialog"
        aria-modal="true"
        aria-label="Confirm cancel shift"
        onClick={(event) => event.stopPropagation()}
      >
        <Heading>Confirm cancellation</Heading>

        <Message>Are you sure you want to cancel?</Message>

        <Message>
          This will result in the cancellation of:
          {totalAccepted > 0 && (
            <BookingCount color={COLORS.RED}>
              {totalAccepted} accepted booking(s)
            </BookingCount>
          )}
          {totalApplied > 0 && (
            <BookingCount color={COLORS.MAIN_ORANGE}>
              {totalApplied} applied booking(s)
            </BookingCount>
          )}
          {totalReserved > 0 && (
            <BookingCount color={COLORS.MAIN_ORANGE}>
              {totalReserved} reserved booking(s)
            </BookingCount>
          )}
        </Message>

        <Actions>
          <Action>
            <RotaButton
              onClick={onClose}
              disabled={isLoading}
              size="large"
              variant="outlined"
            >
              Stop
            </RotaButton>
          </Action>

          <Action>
            <RotaButton
              onClick={onProceed}
              disabled={isLoading}
              size="large"
              variant="contained"
              isLoading={isLoading}
            >
              Proceed
            </RotaButton>
          </Action>
        </Actions>
      </Dialog>
    </Overlay>
  );
};
